<script setup lang="ts">
import CustomButton from "@/components/Button/Button.vue";
import { VDateInput } from "vuetify/labs/VDateInput";
import { ref } from "vue";
import { createTripExpense } from "@/api";
import { Expense } from "@/models/Expense";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  tripId: string;
}>();

const emit = defineEmits<{
  onCompleted: [void];
}>();

const formObj = ref<Partial<Expense>>({
  amount: 0,
  date: null,
  notes: '',
  type: 'groceries',
});

function onSubmit() {
  createTripExpense(props.tripId, formObj.value)
    .then(() => {
      emit('onCompleted');
    })
    .catch((error) => {
      console.error(error);
    });
}

const { t } = useI18n(); // Use the i18n instance
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <VSelect :items="['groceries', 'coffee', 'drinks', 'restaurant']" variant="underlined"
      :label="t('expenseForm.typeLabel')" v-model="formObj.type">
    </VSelect>
    <div class="flex flex-row gap-4">
      <VTextField v-model.number="formObj.amount" :label="t('expenseForm.amountLabel')" variant="underlined"
        type="number" min="0">
        <template #append-inner>
          <div class="h-6 w-6 flex items-center justify-center">
            <img src="@/assets/icons/svg/Euro_24x24.svg" alt="Euro" width="13" height="13" />
          </div>
        </template>
      </VTextField>
      <div class="w-[247px]">
        <VDateInput v-model="formObj.date" :label="t('expenseForm.dateLabel')" variant="underlined" />
      </div>
    </div>
    <VTextarea v-model="formObj.notes" :label="t('expenseForm.notesLabel')" class="mt-8" variant="underlined"
      :placeholder="t('expenseForm.notesPlaceholder')" />
    <CustomButton type="black" :rounded="true">{{ t('expenseForm.addButton') }}</CustomButton>
  </VForm>
</template>


<style scoped>

</style>
